import { Theme } from "@mui/material/styles";

interface Styles {
  [key: string]: any;
}

export const styles = (theme: Theme): Styles => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  resultComponentContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center"
  },
  resultBody: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: theme.spacing.spacing32_5
  },
  image: {
    marginBottom: theme.spacing.spacing15,
    marginRight: theme.spacing.spacing5
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.size.md,
    marginBottom: theme.spacing.spacing4
  },
  text: {
    fontSize: theme.typography.size.sm
  },
  buttonsSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: theme.width.full
  },
  link: {
    marginBottom: theme.spacing.spacing20,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.size.sm,
    color: theme.palette.primary.main
  },
  modalResultContainer: {
    display: "flex",
    flexDirection: "column",
    padding: `${theme.spacing.spacing21} ${theme.spacing.spacing11}`
  }
});
